import moment from "moment";

export const getFromToVariablesForWeekPicker = (week, weekToCompare) => {
  const from = moment()
    .isoWeek(week)
    .startOf("isoWeek")
    .toISOString()
    .replace("Z", "");
  const to = moment()
    .isoWeek(week)
    .endOf("isoWeek")
    .toISOString()
    .replace("Z", "");

  const fromCompare = moment()
    .isoWeek(weekToCompare)
    .startOf("isoWeek")
    .toISOString()
    .replace("Z", "");
  const toCompare = moment()
    .isoWeek(weekToCompare)
    .endOf("isoWeek")
    .toISOString()
    .replace("Z", "");

  return {
    from,
    to,
    fromCompare,
    toCompare,
  };
};

export const getFromToVariablesForMonthPicker = (month) => {
  const from = moment()
    .set("month", month)
    .startOf("month")
    .toISOString()
    .replace("Z", "");
  const to = moment()
    .set("month", month)
    .endOf("month")
    .toISOString()
    .replace("Z", "");

  return {
    from,
    to,
  };
};

export const getDateRangeIncludingLastWeekStartDay = (dateRange) => {
  return {
    from: moment(dateRange[0]).startOf("isoWeek").subtract(7, "days"),
    to: moment(dateRange[1]),
  };
};
